import { Server } from '@wajeez-web/core/api-base';
import { handleDispatchResult } from '@wajeez-web/core/utils';
import { store } from '@wajeez-web/stores/base';

import {
  assignPromoCodeToUtilityUserAsync,
  assignPublisherToUtilityUserAsync,
  getUtilityPromoCodeAnalysisAsync,
} from './slices';

export const assignPromoCodeToUtilityUser = async (
  data: Server.AssignPromoCodeAliasToUtilityUserInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(assignPromoCodeToUtilityUserAsync(data));

  return handleDispatchResult(res, onSuccess);
};

export const assignPublisherToUtilityUser = async (
  data: Server.UpdateUtilityUserPublisherCommand,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(assignPublisherToUtilityUserAsync(data));

  return handleDispatchResult(res, onSuccess);
};

export const getSalesPromoCodeAnalysis = async (
  onSuccess?: () => void | Promise<void>,
  onComplete?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getUtilityPromoCodeAnalysisAsync());

  return handleDispatchResult(res, onSuccess, onComplete);
};
